import HomeView from '@/views/HomeView.vue'
import Sidebar from '@/components/nav/NavComonents.vue'

export default [
    {
        path: '/marketingManage',
        name: '营销管理',
        meta: {
            title: "营销管理",
        },
        redirect: '/marketingManage/couponSetting',
        leaf: false, //是否为单节点，增加属性
        menuShow: true,
        component: HomeView,
        icoClass: 'el-icon-user',
        children: [
            {
                path: '/marketingManage/couponSetting',
                name: "优惠券设置",
                meta: {
                    title: "优惠券设置",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/marketingManage/couponSetting.vue'),
                    sidebar: Sidebar
                }
            },
            {
                path: '/marketingManage/couponRecords',
                name: "优惠券记录",
                meta: {
                    title: "优惠券记录",
                },
                // leaf: true, //是否为单节点，增加属性
                menuShow: true,
                icoClass: 'el-icon-user',
                components: {
                    default: () => import('@/views/marketingManage/couponRecords.vue'),
                    sidebar: Sidebar
                }
            }
        ]
    }
]